export default class Toggle {

    static initializeEvents() {
        Array
            .from(document.querySelectorAll('.js-toggle[data-toggle-target]'))
            .forEach(toggle => {
                const targetElementSelector = toggle.getAttribute('data-toggle-target');
                if (targetElementSelector === 'option') {
                    toggle.addEventListener('change', event => {
                        event.preventDefault();

                        const toggleElement = event.currentTarget;
                        const targetElement = document.getElementById(toggleElement.value);

                        if (!targetElement) {
                            console.warn('[JS-Toggle]: Missing target element for selector: ' + targetElementSelector);
                            return;
                        }

                        Array
                            .from(targetElement.parentNode.children)
                            .forEach(siblingElement => siblingElement.classList.add('hidden'));

                        targetElement.classList.toggle('hidden');
                    });
                } else {
                    toggle.addEventListener('click', event => {
                        event.preventDefault();

                        const toggleElement = event.currentTarget;
                        const targetElementSelector = toggleElement.getAttribute('data-toggle-target');
                        const targetElementReverse = toggleElement.getAttribute('data-toggle-reverse') === 'false';
                        const invisibleElements = document.querySelectorAll(targetElementSelector);

                        Array
                            .from(invisibleElements)
                            .forEach(targetElement => targetElement.classList.toggle('hidden'));

                        if (targetElementReverse) {
                            toggleElement.parentNode.removeChild(toggleElement);
                        }
                        invisibleElements[0].focus();
                    });
                }
            });

        Array
            .from(document.querySelectorAll('.js-toggle[data-toggle-target-visible][data-toggle-target-hidden]'))
            .forEach(toggle => {
                toggle.addEventListener('click', event => {
                    const toggleElement = event.currentTarget;
                    const hiddenTargetElementSelector = toggleElement.getAttribute('data-toggle-target-hidden');
                    const visibleTargetElementSelector = toggleElement.getAttribute('data-toggle-target-visible');

                    Array
                        .from(document.querySelectorAll(hiddenTargetElementSelector))
                        .forEach(targetElement => targetElement.classList.add('hidden'));

                    Array
                        .from(document.querySelectorAll(visibleTargetElementSelector))
                        .forEach(targetElement => targetElement.classList.remove('hidden'));

                    Array
                        .from(toggleElement.parentNode.parentNode.querySelectorAll('input[type="radio"]'))
                        .forEach(input => input.checked = false);

                    const toggleElementInput = toggle.querySelector('input[type="radio"]');
                    if (toggleElementInput) {
                        toggleElementInput.checked = true;
                    }
                });
            });

        // Pour l'impression, les composants "toggle" s'ouvrent tous
        window.addEventListener('beforeprint', () => {
            Array
                .from(document.querySelectorAll('.js-toggle[data-toggle-target]'))
                .forEach(toggle => {
                    const targetElementSelector = toggle.getAttribute('data-toggle-target');
                    if (targetElementSelector === 'option') {
                            const targetElement = document.getElementById(toggle.value);

                            if (!targetElement) {
                                console.warn('[JS-Toggle]: Missing target element for selector: ' + targetElementSelector);
                                return;
                            }

                            Array
                                .from(targetElement.parentNode.children)
                                .forEach(siblingElement => siblingElement.classList.add('hidden'));

                            targetElement.classList.toggle('hidden');
                    } else {
                            const targetElementSelector = toggle.getAttribute('data-toggle-target');
                            const invisibleElements = document.querySelectorAll(targetElementSelector);

                            Array
                                .from(invisibleElements)
                                .forEach(targetElement => targetElement.classList.toggle('hidden'));
                    }

                });
        });

        // Après l'impression, les composants "toggle" se ferment tous
        window.addEventListener('afterprint', () => {
            Array
                .from(document.querySelectorAll('.js-toggle[data-toggle-target]'))
                .forEach(toggle => {
                    const targetElementSelector = toggle.getAttribute('data-toggle-target');
                    if (targetElementSelector === 'option') {
                        const targetElement = document.getElementById(toggle.value);

                        if (!targetElement) {
                            console.warn('[JS-Toggle]: Missing target element for selector: ' + targetElementSelector);
                            return;
                        }

                        Array
                            .from(targetElement.parentNode.children)
                            .forEach(siblingElement => siblingElement.classList.remove('hidden'));

                        targetElement.classList.toggle('hidden');
                    } else {
                        const targetElementSelector = toggle.getAttribute('data-toggle-target');
                        const invisibleElements = document.querySelectorAll(targetElementSelector);

                        Array
                            .from(invisibleElements)
                            .forEach(targetElement => targetElement.classList.toggle('hidden'));
                    }
                });
        });
    }

}